/**
 * 福利任务bid
 */
export const WELFARE_TASK_BUSINESS_ID = {
  NO_TASK: 0 /** 无任务 */,
  BUSINESS_ID_WELFARE: 301 /** 默认时长任务bid */,
  BUSINESS_ID_FOR_NEW_USER: 302 /** 签到任务bid */,
  BUSINESS_ID_FOR_LOGIN: 303 /** 登录任务bid */,
  WELFARE_NOVEL_SIGN_IN_28DAYS: 304,  // 小说28天签到
  WELFARE_NOVEL_VIDEO: 305,  // 小说激励视频任务
  BUSINESS_ID_FOR_REMIND: 308 /** 提醒任务bid */,
  BUSINESS_ID_FOR_INVITE: 309 /** 小说邀请好友组队任务bid */,
  KUAIBAO_SIGN_IN: 2300,     // 快报,签到
  KUAIBAO_SIGN_IN_ACTIVE: 2301, // 快报,签到活动
  KUAIBAO_INVITE: 2900,      // 快报,邀请
  TREASURE_BOX_TASK: 3203 /** 宝箱任务 */,
  SIGN_IN_AD_VIDEO: 1003 /** 签到完成弹窗激励视频任务 */,
  REGULAR_TASK_LIST_AD_VIDEO: 1004 /** 日常任务完成弹窗激励视频任务 */,
  MAIN_READING_TASK_AD_VIDEO: 1005 /** 极速版主时长任务领钱弹窗激励视频任务 */,
  TREASURE_BOX_TASK_AD_VIDEO: 1006 /** 宝箱激励视频任务 */,
  PUSH_SHARE_TASK: 500 /** PUSH分享任务 */,
};

/**
 * 福利任务状态
 */
export const WELFARE_TASK_EVOLVE = {
  WELFARE_TASK_NOT_STARTED: 0 /** 任务未开始 */,
  WELFARE_TASK_DOING: 1 /** 任务进行中 */,
  WELFARE_TASK_DONE: 2 /** 任务完成 */,
  WELFARE_TASK_CANNOT_DOING: 3 /** 现在无法做的任务 */,
  WELFARE_TASK_ALL_DONE: 4 /** 连续任务全部完成 */,
  WELFARE_TASK_LOCKED_BY_GUID: 5 /** 因单个设备登录多个账号锁定 */,
  WELFARE_TASK_LOCKED_BY_QBID: 6 /** 因单个账号登录多个设备锁定 */,
};

/**
 * 福利奖励类型
 */
export const WELFARE_TYPE = {
  WELFARE_RANDOM_CASH: 0 /** 随机金额，现金 */,
  WELFARE_ORDINARY_COUPON: 1 /** 普通礼券 */,
  WELFARE_ADS_COUPON: 2 /** 广告礼券 */,
  WELFARE_RANDOM_INTEGRAL: 3 /** 随机金币(积分) */,
  WELFARE_FIXED_CASH: 4 /** 固定金额 */,
  WELFARE_FIXED_INTEGRAL: 5 /** 固定金币(积分) */,
  WELFARE_VIDEO_VIP: 6 /** 腾讯视频vip */,
  WELFARE_READ_TIME: 7 /** 阅读时长 */,
  WELFARE_BOOK: 8 /** 图书 */,
  WELFARE_LOTTERY: 9 /** 抽奖机会 */,
  WELFARE_ZT_COUPON: 10 /** 中台优惠券 */,
};

/**
 * 中台优惠券类型
 */
export const ZT_COUPON_TYPE = {
  COMMON_COUPON: 1 /** 全品类优惠券 */,
  SINGLE_PRODUCT_COUPON: 2 /** 单品类优惠券 */,
};

/**
 * 优惠券来源
 */
export const ZT_COUPON_SOURCE = {
  WEI_DIAN_COUPON: 3 /** 微店优惠券 */,
};

export const TRADE_STATUS = {
  TsWaitForDeal: 100 /** 处理中 */,
  TsInDealing: 101 /** 待处理 */,
  TsIsSuccessed: 104 /** 成功 */,
  TsIsFailed: 105 /** 失败 */,
};

export const TRANSFER_STATUS = {
  TfsSuccess: 0 /** 成功 */,
  TfsNoAuth: 5 /** 未授权 */,
  TfsAPIError: 6 /** 接口异常 */,
};

export const ZT_COUPON_STATUS = {
  UNRECEIVED: 'UNRECEIVED' /** 未领取 */,
  SENDED: 'SENDED' /** 已领取 */,
  USED: 'USED' /** 已核销 */,
  EXPIRED: 'EXPIRED' /** 已过期 */,
};

export const GET_COUPON_AUTH_RROR = {
  USuccess: 0 /** 绑定成功 */,
  UError: 1 /** 绑定失败 */,
  UWxAuthError: 2 /** 微信授权失败 */,
  UWXAuthCancel: 3 /** 微信取消授权 */,
};
